import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from '../../../../core';
import { ClienteAnaliseMercadoFilter, ClienteAnaliseMercadoViewProps } from '../../adapters';
import { ClienteAnaliseMercadoViewService } from '../../services';
import { ClienteAnaliseMercadoRAPFormTableComponent } from '../../rap/components/form-table';

@Component({
    selector: 'sgt-cliente-analise-mercado-rap-view',
    templateUrl: './cliente-analise-mercado-rap-view.component.html',
    styleUrls: ['./cliente-analise-mercado-rap-view.component.less']
})
export class ClienteAnaliseMercadoRAPViewComponent implements OnInit, OnDestroy {
    /** Subscription para o evento de load da view */
    private loadSub$: Subscription;

    /** Subscription das props da view das Análises de Mercado */
    private propsSub$: Subscription;
    /** Props da view das Análises de Mercado */
    props: ClienteAnaliseMercadoViewProps;

    @ViewChild('formTable') formTable: ClienteAnaliseMercadoRAPFormTableComponent;

    constructor(private messageService: MessageService,
                private clienteAnaliseMercadoViewService: ClienteAnaliseMercadoViewService) { }

    ngOnInit(): void {
        this.initSubscriptions();
    }

    /** Inicia as subscriptions nos eventos da view */
    private initSubscriptions() {
        // Load
        this.loadSub$ = this.clienteAnaliseMercadoViewService.load$.subscribe(filter => this.load(filter));
        // Props
        this.propsSub$ = this.clienteAnaliseMercadoViewService.props$.subscribe(props => this.props = props);
    }

    /** Carrega o dash */
    private load(filter: ClienteAnaliseMercadoFilter) {
        try {
            this.formTable?.load(filter, null);
        } catch (error) {
            this.messageService.error('Tente atualizar a página e se o erro persistir entre em contato com o suporte', 'Erro ao carregar a visualização das Análises de Mercado RAP', error);
        }
    }

    /** Realiza os unsubscribes nos eventos da view */
    private destroySubscriptions() {
        // Load
        this.loadSub$.unsubscribe();
        // Props
        this.propsSub$.unsubscribe();
    }

    ngOnDestroy(): void {
        this.destroySubscriptions();
    }
}
